/**
 * VGP Collection Grid Toggle
 * Handles 3/4 column grid switching with localStorage persistence
 * Part of BUILD051 Theme Cleanup
 */
(function() {
  'use strict';

  var STORAGE_KEY = 'vgp-grid-cols';
  var VALID_COLUMNS = ['3', '4']; // Whitelist

  function init() {
    var gridToggle = document.querySelector('[data-vgp-grid-toggle]');
    var productGrid = document.querySelector('[data-vgp-product-grid]');

    if (!gridToggle || !productGrid) return;

    var buttons = gridToggle.querySelectorAll('.grid-toggle__btn');

    // Restore saved preference
    restoreSavedPreference(buttons, productGrid);

    // Attach click handlers
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        handleGridToggle(this, buttons, productGrid);
      });
    });
  }

  function handleGridToggle(clickedBtn, allButtons, grid) {
    var cols = clickedBtn.getAttribute('data-grid-cols');

    // Validate against whitelist
    if (VALID_COLUMNS.indexOf(cols) === -1) {
      console.warn('[VGP Grid] Invalid column value:', cols);
      return;
    }

    // Update button states
    allButtons.forEach(function(btn) {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    });
    clickedBtn.classList.add('is-active');
    clickedBtn.setAttribute('aria-pressed', 'true');

    // Update grid classes
    grid.classList.remove('product-grid--cols-3', 'product-grid--cols-4');
    grid.classList.add('product-grid--cols-' + cols);

    // Save preference
    savePreference(cols);
  }

  function restoreSavedPreference(buttons, grid) {
    try {
      // Guard against empty buttons NodeList
      if (!buttons || buttons.length === 0) return;

      var savedCols = localStorage.getItem(STORAGE_KEY);

      // Validate against whitelist
      if (!savedCols || VALID_COLUMNS.indexOf(savedCols) === -1) return;

      // Find saved button within the provided buttons NodeList (not global DOM query)
      var savedBtn = null;
      buttons.forEach(function(btn) {
        if (btn.getAttribute('data-grid-cols') === savedCols) {
          savedBtn = btn;
        }
      });
      if (!savedBtn) return;

      buttons.forEach(function(btn) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      });
      savedBtn.classList.add('is-active');
      savedBtn.setAttribute('aria-pressed', 'true');

      grid.classList.remove('product-grid--cols-3', 'product-grid--cols-4');
      grid.classList.add('product-grid--cols-' + savedCols);
    } catch (e) {
      console.warn('[VGP Grid] localStorage error:', e);
    }
  }

  function savePreference(cols) {
    try {
      localStorage.setItem(STORAGE_KEY, cols);
    } catch (e) {
      console.warn('[VGP Grid] localStorage save error:', e);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
